import { getCurrentRootDomain } from "./getCurrentRootDomain";
import { withDeviceIdParam } from "./withDeviceIdParam";

export const TRUEGATE_SUBDOMAIN = "t";

export const getTruegateHostUrl = (path: string) => {
    if (typeof window === "undefined") return path;
    const root = getCurrentRootDomain();
    if (!root) return path;
    const url = new URL(path, root);
    const parts = url.hostname.split(".");
    if (parts[0] !== TRUEGATE_SUBDOMAIN) parts.unshift(TRUEGATE_SUBDOMAIN);
    url.hostname = parts.join(".");
    return withDeviceIdParam(url.toString());
};

